<template>
  <div class="gd606-chart common-border">
    <div
      class="common-border2"
      :style="{ height: `${height}px`, cursor: 'pointer' }"
      v-loading="pageLoading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
      :element-loading-text="loadingText"
      @click="handleSubstanceFlow(name.split(' ')[0])"
    >
      <el-row class="header">
        <el-col :span="24">
          <span class="sensor-name">{{ name }}:</span>
          <span class="value">{{ lastValue }}</span>
          <span class="unit-name">{{ unitName }}</span>
        </el-col>
      </el-row>
      <el-row class="center mt-15" type="flex" justify="center" align="middle">
        <el-col tag="span" :span="12">{{ $t('安装状态') }}：{{ $t(status.install) }}</el-col>
        <el-col tag="span" :span="12">{{ $t('运行状态') }}：{{ $t(status.run) }}</el-col>
      </el-row>
      <el-row class="center" type="flex" justify="center" align="middle">
        <el-col tag="span" :span="12">
          {{ $t('故障状态') }}：
          <span :class="status.faultClass">{{ $t(status.fault) }}</span>
        </el-col>
        <el-col tag="span" :span="12">
          {{ $t('报警状态') }}：
          <span :class="status.alarmClass">{{ $t(status.alarm) }}</span>
        </el-col>
      </el-row>
      <el-row class="center" v-if="gasTypeName" type="flex" align="middle">
        <el-col tag="span" :span="12">{{ $t('气体类型') }}：{{ gasTypeName }}</el-col>
        <el-col tag="span" :span="12"></el-col>
      </el-row>

      <div class="chart-box">
        <v-chart :options="opt" :autoresize="true"></v-chart>
      </div>
    </div>
  </div>
</template>

<script>
import casMixin from '@/mixins/deviceCasMixin';

import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/views/realdata/FCBR-100/options';
import { tools } from '../utils';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    height: Number
  },
  inject: ['time'],
  mixins: [casMixin],

  data() {
    return {
      name: '',
      unit: '',
      unitName: '',
      lastValue: '',
      gasTypeName: '',
      status: {
        install: '',
        run: '',
        alarm: '',
        fault: ''
      },
      chart: [],
      faker: {
        sns: [],
        valueRangeList: {
          'CS-R': [0.1, 0.15],
          CO: [11, 15],
          H2S: [1, 2]
        },
        transform: {
          H2S: {
            code: 'CH3',
            value: 0,
            unitName: 'PPB',
            name: '沙林',
            gasTypeName: ''
          }
        }
      },
      opt: lineAreaStyle({
        color: '#009fe9',
        dataZoom: {
          start: 0,
          type: 'inside'
        },
        series: [
          {
            symbol: 'emptyCircle',
            areaStyle: { color: graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)') }
          }
        ],
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#009fe9'
            }
          }
        },
        grid: {
          top: 28,
          left: 30,
          right: 30,
          bottom: 20
        }
      })
    };
  },
  methods: {
    ...tools,
    modifyChart(data) {
      this.lastValue = data;
      if (this.chart.length >= 20) this.chart.shift();
      this.chart.push([this.time.begin, data]);
      this.opt.series[0].data = this.chart;
    },
    dataFaker(n) {
      if (this.faker.sns.includes(this.$route.params.sn)) {
        const { valueRangeList, transform } = this.faker;

        if (n.code in transform) {
          Object.assign(n, transform[n.code]);
        }

        if (n.code in valueRangeList) {
          const [min, max] = valueRangeList[n.code];
          Object.assign(this.opt.yAxis, {
            min,
            max
          });
        }
      }
    },
    setState(n) {
      Object.assign(this, {
        name: n.name,
        unit: n.unit,
        unitName: n.unitName,
        gasTypeName: n.gasTypeName
      });

      Object.assign(this.status, {
        install: this.pumpInstallText(n.installState),
        run: this.pumpRunText(n.runstate),
        fault: this.pumpFaultText(n.faultState),
        faultClass: this.pumpFaultClass(n.faultState),
        alarm: this.pumpAlarmText(n.alarmState),
        alarmClass: this.pumpAlarmClass(n.alarmState)
      });
    },
    setData(n) {
      this.setState(n);
      this.modifyChart(n.value);
    },
    setDataList(list, data) {
      this.setState(data);

      this.chart.push(...list.map(e => [e.beginTime, e.value]));
      this.opt.series[0].data = this.chart;
    }
  },
  watch: {
    data: 'setData'
  }
};
</script>

<style lang="scss">
.gd606-chart {
  --chart-calc-height: 140px;
  --center-font-size: 16px;

  @media screen and (max-width: 1200px) {
    --chart-calc-height: 100px;
    --center-font-size: 13px;
  }

  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 4px;
  .header {
    font-size: 18px;
    background: #013c5d;
    padding: 12px 10px;
    border-radius: 4px;
    font-weight: bold;

    .sensor-name,
    .value,
    .unit-name {
      margin-right: 5px;
    }

    .unit-name {
      font-size: 12px;
    }
  }
  .center {
    padding: 5px;
    font-size: var(--center-font-size);
    .el-col {
      text-align: center;
    }
  }
  .chart-box {
    height: calc(100% - var(--chart-calc-height));
  }
}
</style>
